module.exports = __webpack_public_path__ + "static/media/goal.5b20df80.svg";